import { useEffect, useState } from "react";
import ActiveOrder from "./component";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const ActiveOrderContainer = () => {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
   const [busyFlag,setBusyFlag]=useState(null)
    const [busyPopupFlag,setBusyPopupFlag]=useState(null)
    const [machineError,setMachineError]=useState(null)
  const [activeOrder, setActiveOrder] = useState(null);
  const [epochtime, setEpochTime] = useState([]);
  const [totalAm, setTotalAm] = useState([]);
  const [cancleflag, setCancleflag] = useState(false);
  const [cancleOrderID, setCancleOrderID] = useState(null);
  const [cancleErrorflag, setCancleErrorflag] = useState(false);
  const [cancleErrorMsg, setCancleErrorMsg] = useState("");
  const [cancleSuccessflag, setCancleSuccessflag] = useState(false);
  const [cancleSuccessMsg, setCancleSuccessMsg] = useState("");
const [loader,setLoader]=useState(false)
  const { makeApiRequest } = useApiRequest();

  // Fetch active orders
  const ActiveOrdersList = () => {
     setLoader(true)
    makeApiRequest({
      
      url: `${API_BASE_URL}/consumerbe/api/v2/order/${orderId}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      data: [{ slotId: 100, count: 1 }], // Adjust count if needed
      handleSuccess: (res) => {
        
        const orders = res.data.data
        //console.log("orders",orders)
        setActiveOrder(orders);
       
 setLoader(false)
        // Collect epoch times and total amounts
  

    
      },
      handleError: (error) => {
         setLoader(false)
        if (error.response?.status === 401 || error.response?.status === 403) {
          navigate("/login");
        } else {
          toast.error(error.response?.data?.status?.code || "Something went wrong", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
        }
      },
    });
  };

  useEffect(() => {
    ActiveOrdersList();
    
  }, []);

   const fetchCode = async () => {
     setLoader(false)
      try {
        const response = await axios.get(
          `${API_BASE_URL}/consumerbe/api/v1/contactless/generate-code/${orderId}`,
          {
            headers: {
              Authorization: `Bearer ${UserJWTAuth}`,
              "x-app-platform": "web",
              "x-app-version": "v1.0.1",
              "x-device-id": localStorage.getItem("uuid"),
            },
          }
        );
        //console.log("busy khan", response);
        //setCodes(response.data.data.codes);
        //setOrderId(response.data.data.orderId);
         setBusyFlag(false)
         setBusyPopupFlag(true)
           navigate(`/vendOrder/number/${orderId}`, { replace: true }); 
       
      } catch (err) {
        //console.error("busy khan ❌ Fetch error",err.response.data.status.code);
         setBusyFlag(true)
         setBusyPopupFlag(true)
         //if()
        if(err.response.data.status.code=="FORBIDDEN"){
         const  message=err.response.data.status.message;
         
if (message.toLowerCase().includes("offline") || message.toLowerCase().includes("office")) {
  setMachineError("Offline")
} else {
setMachineError("Busy")
}
        }
         
    };  
  }  

  // Cancel Order
  const CancleOrder = () => {

 setLoader(true)
    makeApiRequest({

      url: `${API_BASE_URL}/consumerbe/api/v2/order/${cancleOrderID}`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: (res) => {
        setLoader(false)
        if (res.data.status.success) {
          ActiveOrdersList(); // refresh orders
          setCancleflag(false);
          setCancleSuccessflag(true);
          setCancleSuccessMsg("Order Cancelled");
        
        } else {
          setCancleflag(false);
          setCancleErrorflag(true);
          setCancleErrorMsg(res.data.status.message || "Unable to cancel order");
        
        }
      },
      handleError: (error) => {
          setLoader(false)
        setCancleflag(false);
        setCancleErrorflag(true);
        setCancleErrorMsg(error.response?.data?.status?.message || "Something went wrong");
       
      },
    });
  };

  const CancleOrderset = (e, id) => {
    setCancleOrderID(id);
    setCancleflag(true);
  };

  return (
    <ActiveOrder
      activeOrder={activeOrder}
      CancleOrder={CancleOrder}
      cancleflag={cancleflag}
      CancleOrderset={CancleOrderset}
      setCancleErrorflag={setCancleErrorflag}
      cancleErrorflag={cancleErrorflag}
      setCancleErrorMsg={setCancleErrorMsg}
      cancleErrorMsg={cancleErrorMsg}
      cancleSuccessflag={cancleSuccessflag}
      cancleSuccessMsg={cancleSuccessMsg}
      setCancleSuccessflag={setCancleSuccessflag}
      amounts={totalAm}
      epochtime={epochtime}
      setCancleflag={setCancleflag}
      setBusyPopupFlag={setBusyPopupFlag}
      busyPopupFlag={busyPopupFlag}
      machineError={machineError}
      fetchCode={fetchCode}
      loader={loader}
    />

  );
};

export default ActiveOrderContainer;
